<template>
  <div class="body">
    <Home-Header :navindex="3"></Home-Header>
    <Home-Swiper :slideindex="2"></Home-Swiper>
    <Home-Content ></Home-Content>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a>

  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeSwiper from '../common/Swiper'
import HomeContent from './components//Content'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'technology',
  metaInfo: {
    title: '入库科技型中小企业-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '入库科技型中小企业_可持续发展_税收减免' },
      { name: 'description', content: '上海机巧科技有限公司：具大大提升企业形象，提高品牌影响力和宣传度' }
    ]
  },
  components: {
    HomeHeader, HomeSwiper, HomeContent, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom
  },
  data () {
    return {
      bgf8f6f9: 'bgf8f6f9',
      bgfff: 'bgfff'
    }
  },
  mounted () {
  }
}
// eslint-disable-next-line eol-last
</script>



// WEBPACK FOOTER //
// src/pages/technology/technology.vue